module.exports = {

  isJwtTokenExpired (token) {
    let payload = JSON.parse(atob(token.split('.')[1]))

    return (payload.exp * 1000) <= (new Date().getTime() + 600000)
  },

  getRoles: (token) => JSON.parse(atob(token.split('.')[1])).roles,
  getUsername: (token) => JSON.parse(atob(token.split('.')[1])).username,
  getPayload: (token) => JSON.parse(atob(token.split('.')[1]))
}



// WEBPACK FOOTER //
// ./src/utils/SessionService.js